<style>
    h1 {
        text-transform: capitalize;
    }
</style>
<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Buat Packing</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/pembelian/print-invoice/'+id_transaksi)" class="btn btn-icon icon-left btn-primary"><i class="fas fa-file"></i> Preview Invoice</a>
            </div>
          </div>
         <div class="section-body">
            <h2 class="section-title">Harga Total </h2>
            <p class="section-lead">Dibayar </p>

            <div class="row">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Supplier</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Supplier</label>
                                <select :disabled="supplierDis" id="supplier" class="form-control select2">
                                    <option v-for="(option,index) in supplierList" v-bind:key="index" :value="index" >{{ option.display_name}} </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Alamat Supplier</label>
                                <textarea disabled class="form-control" v-model="alamat" @focus="auto_alamat()"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input disabled type="text" v-model="email" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Packing</h4>
                        </div>
                        <div class="card-body">
                            <!-- <div class="form-group">
                                <label>Nomor Invoice</label>
                                <input type="text" v-model="nomor_invoice" class="form-control">
                            </div> -->
                            <div class="form-group">
                                <label>Nomor Surat Jalan / Pengiriman</label>
                                <input type="text" v-model="nomor_pengiriman" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Tanggal Pengiriman</label>
                                <vc-date-picker v-model="tanggal_pengiriman" :input-props='{class: "form-control",placeholder: "Masukkan tanggal pengiriman"}'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Tambahan</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Pesan</label>
                                <textarea class="form-control" v-model="pesan" ></textarea>
                            </div>
                            <div class="form-group mb-0">
                                <label>Memo</label>
                                <textarea class="form-control" v-model="memo" ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Daftar Packing Produk</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-striped">
                                <tr>
                                    <th>No.</th>
                                    <th>Kode Produk</th>
                                    <th>Produk</th>
                                    <th>Nomor PO</th>
                                    <th>Qty</th>
                                    <th>Satuan</th>
                                    <th>Pack ?</th>
                                    <th>Qty Pack</th>
                                    <th>Sisa Qty</th>
                                </tr>
                                <tbody v-if="bodyRender">
                                    <tr v-for="(data,index) in produkList" v-bind:key="index">
                                        <td> {{ index+1 }} </td>
                                        <td>
                                            {{ data.kode_produk }}
                                        </td>
                                        <td>
                                           {{ data.nama_produk }} 
                                        </td>
                                        <td>
                                            {{ data.nomor_transaksi }}
                                        </td>
                                        <td>
                                            {{ data.qty }}
                                        </td>
                                        <td>
                                            {{ data.nama_satuan }}
                                        </td>
                                        <td>
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" :id="'check_'+index" v-model="data.pack_check">
                                                <label class="custom-control-label" :for="'check_'+index" >Check jika barang dipack</label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input :disabled="data.pack_check == 0" :max="data.qty - data.qty_dikirim" min="0" type="number" class="form-control" v-model="data.qty_pack">
                                            </div>
                                        </td>
                                        <td>
                                            {{ data.qty - data.qty_dikirim }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="submitPacking()" class="btn btn-info"> <i class="fas fa-box"></i> Set Packing</button>
                    <button @click="goBack()" class="btn btn-danger">Kembali</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<style>
td {
    height: 30px;
}
</style>

<script>
import Vue from 'vue'
import VCalendar from 'v-calendar';

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD',
        input : 'YYYY-MM-DD'
      }
    }
  }
});

export default {
    data() {
        return {
            id_transaksi : '',
            transaksiDetail : [],
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            jenis_transaksi : '',
            tipe_transaksi : '',
            produkList : [],
            bodyRender : true,
            alamat : '',
            email : '',
            nomor_invoice : '',
            nomor_pengiriman : '',
            // packingList : [],
            supplier : '',
            que : 0,
            supplierList : [],
            supplierDis : false,
            tanggal_pengiriman : '',
            id_kontak : '',
            pesan : '',
            memo : ''
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            this.nomor_pengiriman = ''
            this.nomor_invoice = '',
            this.tanggal_pengiriman = ''
            //get supplier list
            this.$http.post("Kontak/getKontakList/supplier").then(result => {
                if(result.data.code == '00'){
                    console.log('kontak supplier empty')
                }else {
                    this.supplierList = result.data.detail
                    this.que = 1
                    if(this.que == 1){
                        this.getTransaksiDetail()
                    }
                }
            })
        },
        getTransaksiDetail : function() {
            if(this.$route.params.id_transaksi != null){
                this.$root.is_loading = true
                this.id_transaksi = this.$route.params.id_transaksi
                this.$http.post("Transaksi/getTransaksiDetail/"+this.id_transaksi).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.transaksiDetail = result.data.detail
                        this.supplier = this.transaksiDetail.detail.id_kontak
                        this.jenis_transaksi = result.data.detail.detail.jenis_transaksi
                        this.tipe_transaksi = result.data.detail.detail.tipe_transaksi+" #"+result.data.detail.detail.nomor_transaksi
                        this.id_kontak = this.transaksiDetail.detail.id_kontak
                        let that = this
                        this.$http.post("Transaksi/getProdukListByKontak/"+that.transaksiDetail.detail.id_kontak+"/"+that.transaksiDetail.detail.jenis_transaksi+"/"+that.transaksiDetail.detail.id_transaksi).then(result => {
                            if(result.data.code == '00') {
                                that.$parent.toastr = {
                                    title : 'Error',
                                    message: 'Something went wrong, please call developer !',
                                    type : 'error'
                                }
                            }
                            else {
                                if(result.data.detail.length == 0){
                                    that.$parent.toastr = {
                                        title : 'Warning',
                                        message: 'Tidak ada Produk PO',
                                        type : 'error'
                                    }
                                }
                                that.produkList = result.data.detail
                                that.produkList.forEach(function(item,index){
                                    that.produkList.qty_pack = 0
                                    if(item.pack_check == 1){
                                        that.produkList[index].pack_check = true
                                    }else{
                                        that.produkList[index].pack_check = false
                                    }
                                })
                            }
                        }, error => {
                            console.log('gk ok')
                            context.errors = errors;
                        });
                                                
                        this.supplierList.forEach(function(item,index){
                            if(item.id_kontak == that.supplier){
                                that.supplier = index
                                that.alamat = that.transaksiDetail.detail.alamat_transaksi
                                that.email = that.transaksiDetail.detail.email_transaksi
                                that.supplierDis = true
                                $("#supplier").val(that.supplier).trigger('change');
                                return that.supplier
                            }
                        })
                    }
                    this.$root.is_loading = false;
                }, error => {
                    this.$root.is_loading = false;
                    console.log('gk ok')
                    context.errors = errors;
                });

            }
        },
        submitPacking: function() {
            
            if(this.nomor_pengiriman == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan nomor pengiriman / surat jalan !',
                    type : 'warning'
                }
                return false
            }

            
            if(this.tanggal_pengiriman == ''){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Masukkan tanggal pengiriman !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Pastikan data sudah benar !')){
                return false
            }

            var packingList = []
            let that = this
            this.produkList.forEach(function(item,index){
                if(item.pack_check == true){
                    that.produkList[index].total_kirim = parseFloat(item.qty_dikirim) + parseFloat(item.qty_pack)
                    console.log(that.produkList[index].total_kirim);
                    console.log(item.qty);
                    if(that.produkList[index].total_kirim >= item.qty){
                        that.produkList[index].status_packing = 1
                    }
                    else {
                        that.produkList[index].status_packing = 0
                    }
                    console.log(that.produkList[index].status_packing)
                    packingList.push(item)
                }
            })

            if(packingList.length == 0){
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Tidak ada produk di pack !',
                    type : 'warning'
                }
                return false
            }
            
            var formsub = new FormData()

            var objThis = this
            $.map(packingList, function(value,index){
                    formsub.append('dataProduk['+index+'][id_produk]', value.id_produk);
                    formsub.append('dataProduk['+index+'][nama_satuan]', value.nama_satuan);
                    formsub.append('dataProduk['+index+'][nama_produk]', value.nama_produk);
                    formsub.append('dataProduk['+index+'][id_transaksi_produk]', value.id_transaksi_produk);
                    formsub.append('dataProduk['+index+'][qty_send]',value.qty_pack);
                    formsub.append('dataProduk['+index+'][total_kirim]',value.total_kirim);
                    formsub.append('dataProduk['+index+'][status_packing]', value.status_packing);
            });
            
            formsub.append('jenis_progress','pembelian')
            formsub.append('tanggal_pengiriman',this.formatDate(this.tanggal_pengiriman))
            formsub.append('nomor_pengiriman', this.nomor_pengiriman)
            formsub.append('nomor_invoice',this.nomor_invoice)
            formsub.append('pesan', this.pesan)
            formsub.append('memo',this.memo)
            formsub.append('alamat',this.alamat)
            formsub.append('email',this.email)

            this.$http.post("Transaksi/updatePacking/"+this.id_kontak, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Packing berhasil diupdate !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.init();
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Packing gagal diupdate !',
                        type : 'error'
                    }                 
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        goBack() {
            this.$router.replace({ path : window.localStorage.getItem('last_route') })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pembelian/TransaksiCreatePacking.vue